import React, { useState } from "react";

import UserReviews from "./UserReviews";
import UserGallery from "./UserGallery";
import UserDescription from "./UserDescription";
import UserCertifications from "./UserCertifications";

import { Typography, Grid, Stack } from "@mui/material";

const UserTab = ({ info, reviews }) => {
  const [value, setValue] = React.useState("");

  return (
    <Grid container>
      <Grid item sm={2} style={{ marginTop: "100px" }}>
        <Stack spacing={2}>
          <Typography
            onClick={() => setValue("about")}
            style={
              value == "about" || value == ""
                ? {
                    cursor: "pointer",
                    paddingLeft: "10px",
                    color: "#FA8319",
                    borderLeft: "4px solid #FA8319",
                  }
                : { cursor: "pointer", paddingLeft: "10px" }
            }
          >
            About
          </Typography>
          <Typography
            onClick={() => setValue("skills")}
            style={
              value == "skills"
                ? {
                    cursor: "pointer",
                    paddingLeft: "10px",
                    color: "#FA8319",
                    borderLeft: "4px solid #FA8319",
                  }
                : { cursor: "pointer", paddingLeft: "10px" }
            }
          >
            Skills
          </Typography>

          {reviews.length ? (
            <Typography
              onClick={() => setValue("reviews")}
              style={
                value == "reviews"
                  ? {
                      cursor: "pointer",
                      paddingLeft: "10px",
                      color: "#FA8319",
                      borderLeft: "4px solid #FA8319",
                    }
                  : { cursor: "pointer", paddingLeft: "10px" }
              }
            >
              Reviews
            </Typography>
          ) : (
            <></>
          )}

          <Typography
            onClick={() => setValue("certificates")}
            style={
              value == "certificates"
                ? {
                    cursor: "pointer",
                    paddingLeft: "10px",
                    color: "#FA8319",
                    borderLeft: "4px solid #FA8319",
                  }
                : { cursor: "pointer", paddingLeft: "10px" }
            }
          >
            Certificates
          </Typography>
          <Typography
            onClick={() => setValue("gallery")}
            style={
              value == "gallery"
                ? {
                    cursor: "pointer",
                    paddingLeft: "10px",
                    color: "#FA8319",
                    borderLeft: "4px solid #FA8319",
                  }
                : { cursor: "pointer", paddingLeft: "10px" }
            }
          >
            Gallery
          </Typography>
        </Stack>
      </Grid>
      <Grid item sm={9}>
        <UserDescription
          currentValue={value}
          desc={info.personalInfo.description}
          userSkills={info.expertise.skills}
        />
        <UserReviews currentValue={value} userReviews={reviews} />
        <UserCertifications
          currentValue={value}
          certificates={info.documents.certificationData}
        />
        <UserGallery
          currentValue={value}
          galleryPics={info.personalInfo.image}
        />
      </Grid>
    </Grid>
  );
};

export default UserTab;
